import { render, staticRenderFns } from "./BookCategories.vue?vue&type=template&id=6f977af1&"
import script from "./BookCategories.vue?vue&type=script&lang=js&"
export * from "./BookCategories.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports